// modules
import { get, has } from 'lodash'

import httpClient, { catchError } from '@emmacare/common/api/httpClient'

// store
import { setCompanyReferences } from 'src/store/modules/company/refs'

// constants
import {
  COMPANY_REFERENCE_TABLE,
  COMPANY_REFERENCE_TYPES_BY_NUMBERS
} from 'src/utils/constants'

export const fetchCompanyReferences =
  (config: any = {}) =>
  async (dispatch: any) => {
    const { query = {} } = config

    try {
      const { items = [] } = await httpClient.request({
        method: 'get',
        url: {
          pathname: COMPANY_REFERENCE_TABLE,
          query
        }
      })

      const companyReferences: any = {}

      items.forEach((reference = {}) => {
        const type = +get(reference, ['type'], null)
        const referenceName: any = COMPANY_REFERENCE_TYPES_BY_NUMBERS.get(type)

        if (referenceName && !has(companyReferences, referenceName)) {
          companyReferences[referenceName] = [reference]
        } else if (has(companyReferences, referenceName)) {
          companyReferences[referenceName].push(reference)
        }
      })

      dispatch(setCompanyReferences(companyReferences))
    } catch (err) {
      catchError(err)
    }
  }
